import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import React from "react";
import { useScaffold } from "../../../scaffold";

export type ContextLoginProps = {
  email: string;
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onSendEmail: () => void;
  isLoading?: boolean;
  error?: string;
};

export const ContextLogin: React.FC<ContextLoginProps> = ({
  email,
  title = "Verify your email to review the renewal offer",
  subtitle = `We'll send you a link to click at ${email} to verify your identity.`,
  buttonText = "Send verification email",
  onSendEmail,
  isLoading = false,
  error,
}) => {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;
  const ErrorMessage = scaffold.system.errorMessage;
  const Field = scaffold.system.field;

  return (
    <PageBody
      footer={
        <ButtonFooter>
          {error && (
            <Field>
              <ErrorMessage>{error}</ErrorMessage>
            </Field>
          )}
          <Button
            size="lg"
            className="w-full"
            onClick={onSendEmail}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </ButtonFooter>
      }
    >
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 gap-4 flex flex-col text-left">
        <div className="flex flex-col gap-2">
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
      </div>
    </PageBody>
  );
};
